// src/analytics/AnalyticsProvider.js
import React, { useEffect, useMemo } from 'react';
import { AnalyticsContext } from './AnalyticsContext';
import {
  initPosthog,
  posthogTrackEvent,
  posthogIdentifyUser,
  posthogStartSession,
  posthogEndSession,
} from './PosthogAnalytics';

export function AnalyticsProvider({ children }) {
  useEffect(() => {
    // Initialize PostHog on app start
    initPosthog();
  }, []);

  const analyticsValue = useMemo(() => ({
    trackEvent: (eventName, properties) => {
        // console.log(`Tracking event: ${eventName}`, properties);
      posthogTrackEvent(eventName, properties);
    },
    identifyUser: (userId) => {
      // console.log(`Identifying user: ${userId}`);
      posthogIdentifyUser(userId);
    },
    startSession: (sessionId, extraProps) => {
      posthogStartSession(sessionId, extraProps);
    },
    endSession: (sessionId, extraProps) => {
      posthogEndSession(sessionId, extraProps);
    },
  }), []);

  return (
    <AnalyticsContext.Provider value={analyticsValue}>
      {children}
    </AnalyticsContext.Provider>
  );
}
